var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E8F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5566 16.6241C8.34832 16.3898 8.34832 16.0099 8.5566 15.7755L11.9128 11.9998L8.5566 8.22407C8.34832 7.98975 8.34832 7.60985 8.5566 7.37554C8.76488 7.14123 9.10257 7.14123 9.31085 7.37554L13.0442 11.5755C13.2525 11.8099 13.2525 12.1898 13.0442 12.4241L9.31085 16.6241C9.10257 16.8584 8.76488 16.8584 8.5566 16.6241Z",
    fill: "#1899A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1562 16.6241C11.9479 16.3898 11.9479 16.0099 12.1562 15.7755L15.5124 11.9998L12.1562 8.22407C11.9479 7.98975 11.9479 7.60985 12.1562 7.37554C12.3645 7.14123 12.7022 7.14123 12.9105 7.37554L16.6438 11.5755C16.8521 11.8099 16.8521 12.1898 16.6438 12.4241L12.9105 16.6241C12.7022 16.8584 12.3645 16.8584 12.1562 16.6241Z",
    fill: "#1899A2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderArrow);
export default __webpack_public_path__ + "static/media/header-arrow.be6f15c1ef3e736ca83598e752297e16.svg";
export { ForwardRef as ReactComponent };